<div class="col-lg-12 adduser-container-hgt">
  <div class="row child">
    <p-card class="card-spacing-0">
      <span
        class="d-flex justify-content-between align-items-center p-3 globalborder-btm-header">
        <span class="col-auto">
          <h2 class="mb-0">Program Summary</h2>
        </span>
        <div
          class="col-auto d-flex justify-content-between align-items-center gap-3">
          <a
            >Program:<b> {{ programName }}</b></a
          >
          <a
            >Status:<b> {{ programStatus }}</b>
          </a>
          <a> Created: {{ programCreatedDate | date: "yyyy-MM-dd" }} </a>
          <span class="lds-ring inline me-auto ms-2" *ngIf="showSmallLoader">
            <jni-spinner></jni-spinner>
          </span>
          <a class="link" (click)="onProgramEdit()"
            ><i class="pi pi-pen-to-square"></i> Edit</a
          >

          <span class="cross-border" (click)="onCloseModal()"
            ><i class="pi pi-times"></i
          ></span>
        </div>
      </span>
      <div class="col-lg-12 adduser-container-hgt p-3">
        <jni-program-header
          #header
          [parent]="programForm"
          [isReadOnly]="isReadOnly"
          (smallLoaderEvent)="getSmallLoaderStatus($event)"
          [programId]="programId"
          [platformList]="platfromList"
          [facilitatorList]="facilitatorList"
          [threePLList]="threePlList"
          [programData]="programData"
          [validateLogin]="validateLogin"
          (emitOnApprove)="onApprove($event)"
          [pgmDimensionList]="programDimensions"
          [bcList]="bcList"
          [isAdminCheck]="isAdminCheck"
          [isEditDimension]="isEditDimension">
        </jni-program-header>

        <div
          class="d-flex has-sticky gap-3 justify-content-end saveBtn"
          *ngIf="!isReadOnly">
          <!-- <button
            class="btn btn-secondary me-3"
            type="button"
            (click)="onCancel()">
            Cancel
          </button>
          <button
            class="btn btn-primary"
            type="submit"
            [disabled]="!programForm.valid"
            (click)="onProgramUpdate()">
            Save
          </button> -->

          <p-button
            label="Cancel"
            (click)="onCancel()"
            variant="outlined"
            severity="secondary" />

          <p-button
            label="Save"
            [disabled]="!programForm.valid"
            (click)="onProgramUpdate()" />
        </div>

        <div class="mt-4">
          <jni-client-list
            [programId]="programId"
            [isClientLockCheck]="isClientLockCheck"
            (clientSummaryModalEvent)="openClientSummaryModal($event)">
          </jni-client-list>
        </div>
      </div>
    </p-card>
  </div>
</div>

<!-- <div class="orders py-4">
  <div class="mt-2">
    <jni-program-header
      #header
      [parent]="programForm"
      [isReadOnly]="isReadOnly"
      (smallLoaderEvent)="getSmallLoaderStatus($event)"
      [programId]="programId"
      [platformList]="platfromList"
      [facilitatorList]="facilitatorList"
      [threePLList]="threePlList"
      [programData]="programData"
      [validateLogin]="validateLogin"
      (emitOnApprove)="onApprove($event)"
      [pgmDimensionList]="programDimensions"
      [bcList]="bcList"
      [isAdminCheck]="isAdminCheck"
      [isEditDimension]="isEditDimension">
    </jni-program-header>
  </div>

  <div
    class="d-flex has-sticky justify-content-end saveBtn"
    *ngIf="!isReadOnly">
    <button class="btn btn-secondary me-3" type="button" (click)="onCancel()">
      Cancel
    </button>
    <button
      class="btn btn-primary"
      type="submit"
      [disabled]="!programForm.valid"
      (click)="onProgramUpdate()">
      Save
    </button>
  </div>
</div> -->

<jni-modal-stacker
  *ngIf="displayClientSummaryModal"
  [displayModal]="displayClientSummaryModal"
  (closeEvent)="closeClientSummaryModal()">
  <h1 class="panelHeading">Client Summary</h1>
  <div class="panelBody">
    <jni-client-details
      [clientIdFromModal]="clientSummaryAccount"
      (closeEvent)="closeClientSummaryModal()">
    </jni-client-details>
  </div>
</jni-modal-stacker>
